unit Essentials.Web.Lookup.Editor;

interface

uses
  System.SysUtils, System.Variants, System.Classes, Vcl.Graphics,
  Vcl.Controls, Vcl.Forms, Vcl.Dialogs, WebForm.Core, WEBLib.Lists,
  Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.Grids, WEBLib.DBCtrls, WEBLib.Controls,
  WEBLib.Dialogs, Data.DB, WEBLib.DB, Grid.Plugins,
  WEBLib.ExtCtrls, Web, WebLib.WebCtrls,   XData.Web.Connection,
  XData.Web.Client, Types, XData.Web.Dataset, JS;

type
  TEssentialsLookupEditor = class(TCoreWebForm)
    AddButton: TButton;
    cbPageSize: TComboBox;
    EssentialsTable: TDBTableControl;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    LoadButton: TButton;
    DataSource: TDataSource;
    EntitySelector: TLookupComboBox;
    FieldSelector: TLookupComboBox;
    ConfirmationMsg: TMessageDlg;
    procedure AddButtonClick(Sender: TObject);
    procedure LoadButtonClick(Sender: TObject);
    procedure cbPageSizeChange(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure EssentialsTableGetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string;
      AElement: TJSHTMLElementRecord);
    procedure DataSourceStateChange(Sender: TObject);
    procedure EntitySelectorChange(Sender: TObject);
  private
    FIdField: string;
    FGridPlugin: TGridPlugin;
    const RECORD_ID_DELIMITER = ';';
    procedure AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);
    function ConvertIdFieldsIntoRecords(aIdFields: string): string;
    function GetJSArrayFromRecordIds(aRecordIds: string): TJSValueDynArray;
    [Async]
    procedure EditRecord(ARecordId: string); async;
    [Async]
    procedure ToggleActiveRecord(ARecordId: string); async;
    [Async]
    procedure LoadData; async;
    [Async]
    procedure LoadEntityList; async;
    [Async]
    procedure Save; async;
    procedure RefreshControls(aShow: Boolean);
    procedure SetDataSet(aDataSet:TXdataWebDataset);
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  EssentialsLookupEditor: TEssentialsLookupEditor;

implementation

uses Essentials.Web.Shared, Essentials.Web.Lookup.EditLookupValueForm,
SMX.webcore.Types, Essentials.Shared, Essentials.Web.Manager, SMX.Web.Utils, Generics.Collections,
SMX.Web.Layout.Utils, StrUtils;

{$R *.dfm}

procedure TEssentialsLookupEditor.LoadData;
var
  selectedEntity, selectedField: string;
begin
  EssentialsManager.LookUpManager.LookupValuesDataset.Active := True;

  if not Assigned(FGridPlugin) then
  begin
    EssentialsManager.LookUpManager.LookupValuesDataset.QueryString := '';
    FGridPlugin := TGridPlugin.Create(EssentialsTable, EssentialsManager.LookUpManager.LookupValuesDataset, lcPaginator, lbPaginationInfo,
      TSortPair.Create(1, sdAsc));

    FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  end;

  selectedEntity := EntitySelector.Value;
  selectedField := FieldSelector.Value;

  Await(Boolean, EssentialsManager.LookUpManager.LocateLookup(selectedEntity, selectedField));

  FGridPlugin.SetPreparedFilter(EssentialsManager.LookUpManager.GetFilter);
  RefreshControls(True);
end;

procedure TEssentialsLookupEditor.LoadEntityList;
var
  lDef: TdtoLookupDef;
  lName, lCustom: string;
  lAssigned: Boolean;
  lSelectedEntity: string;
begin
  if EssentialsManager.LookUpManager.LookUpDataset.Active and EssentialsManager.LookUpManager.LookUpValuesDataset.Active then
    lSelectedEntity := EssentialsManager.LookUpManager.LookUpDataset.FieldByName('EntityClassName').AsString;

  for lDef in EssentialsManager.LookUpManager.RegisteredEntities do
  begin
    lName := lDef.EntityClassName;
    lAssigned := Assigned(EssentialsManager.CustomNamesManager);
    if lAssigned then
       lCustom := EssentialsManager.CustomNamesManager.EntityCustomName(lName);

    EntitySelector.LookupValues.AddPair(lName, lCustom);
    if lSelectedEntity = lName then
        EntitySelector.ItemIndex := EssentialsManager.LookUpManager.RegisteredEntities.IndexOf(lDef);
  end;

  if EntitySelector.ItemIndex > -1 then
    EntitySelectorChange(EntitySelector)
  else if EntitySelector.LookupValues.Count > 0 then
  begin
    EntitySelector.ItemIndex := 0;
    EntitySelectorChange(EntitySelector);
  end;
end;

procedure TEssentialsLookupEditor.AddButtonClick(Sender: TObject);
begin
  inherited;
  EditRecord('');
end;

procedure TEssentialsLookupEditor.RefreshControls(aShow: Boolean);
begin
  lcPaginator.Visible := aShow;
  lbPaginationInfo.Visible := aShow;
  cbPageSize.Visible := aShow;
  SetHtmlElementVisible('essentials.lookup.PageSizeRow', aShow);
  SetHtmlElementVisible('essentials.lookup.PaginationRow', aShow);
  SetHtmlElementVisible('essentials.lookup.PaginationControls', aShow);
end;

procedure TEssentialsLookupEditor.Save;
var
  lKey: string;
begin
  Await(Boolean, EssentialsManager.LookUpManager.SaveValueChanges);
  lKey := EssentialsManager.LookUpManager.CacheKey(EntitySelector.Value, FieldSelector.Value);
  EssentialsManager.LookUpManager.RemoveFromCache(lKey);
end;

procedure TEssentialsLookupEditor.SetDataSet(aDataSet: TXdataWebDataset);
begin
  DataSource.DataSet := aDataSet;
  AddButton.Enabled := DataSource.DataSet.Active;
end;

procedure TEssentialsLookupEditor.AddRowActions(const ARecordId: string;
  AParentElement: TJSHTMLElement);
  procedure EditClick(Sender: TObject);
  begin
    EditRecord(ARecordId);
  end;

  procedure ToggleActiveClick(Sender: TObject);
  begin
    ToggleActiveRecord(ARecordId);
  end;

var
  Span: THTMLSpan;
  lIsActive: Boolean;
begin
  Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-edit', 'View');
  Span.OnClick := @EditClick;

  lIsActive := DataSource.DataSet.FieldByName('IsActive').AsBoolean;
  if lIsActive then
  begin
    Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-ban', 'Deactivate');
    Span.OnClick := @ToggleActiveClick;
  end
  else
  begin
    Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-check-circle', 'Reactivate');
    Span.OnClick := @ToggleActiveClick;
  end;
end;

procedure TEssentialsLookupEditor.cbPageSizeChange(Sender: TObject);
begin
  inherited;
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

function TEssentialsLookupEditor.ConvertIdFieldsIntoRecords(aIdFields: string): string;
var
  idFieldsArr: TArray<string>;
  idField: string;
begin
    idFieldsArr := aIdFields.Split([RECORD_ID_DELIMITER]);
    Result := '';
    for idField in idFieldsArr do
      Result := IfThen(Result <> '', Result + RECORD_ID_DELIMITER, '') + DataSource.DataSet.FieldByName(idField).AsString;
end;

procedure TEssentialsLookupEditor.DataSourceStateChange(Sender: TObject);
begin
  inherited;
  AddButton.Enabled := DataSource.DataSet.Active;
end;

procedure TEssentialsLookupEditor.ToggleActiveRecord(ARecordId: string);
var
  foundRecord: Boolean;
  lIsActive: Boolean;
  lName, lMsg, lKey: string;
begin
  if ARecordId.Contains(RECORD_ID_DELIMITER) then
    foundRecord := DataSource.DataSet.Locate(FIdField, GetJSArrayFromRecordIds(ARecordId), [])
  else
    foundRecord := DataSource.Dataset.Locate(FIdField, ARecordId, []);

  if foundRecord then
  begin
    lIsActive := DataSource.DataSet.FieldByName('IsActive').AsBoolean;
    lName := DataSource.DataSet.FieldByName('LookupValue').AsString;

    if lIsActive then
    begin
      ConfirmationMsg.Title := 'Deactivate';
      lMsg := Format('Are you sure you want to deactivate %s? It will no longer appear in dropdowns.', [QuotedStr(lName)]);
    end
    else
    begin
      ConfirmationMsg.Title := 'Reactivate';
      lMsg := Format('Are you sure you want to reactivate %s?', [QuotedStr(lName)]);
    end;

    if Await(TModalResult, ConfirmationMsg.ShowDialog(lMsg, mtConfirmation, [mbYes, mbNo])) = mrYes then
    begin
      DataSource.DataSet.Edit;
      DataSource.DataSet.FieldByName('IsActive').AsBoolean := not lIsActive;
      DataSource.DataSet.Post;
      Await(Boolean, EssentialsManager.LookUpManager.SaveValueChanges);
      lKey := EssentialsManager.LookUpManager.CacheKey(EntitySelector.Value, FieldSelector.Value);
      EssentialsManager.LookUpManager.UpdateCacheEntry(lKey, lName, not lIsActive);
    end;
  end;
end;

procedure TEssentialsLookupEditor.EditRecord(ARecordId: string);
var
  AForm: TEditLookupValue;
  lNewValue, lDescription, lMsg: string;
  lSortOrder: Integer;
  lDeactivatedFound: Boolean;
begin
  AForm := TEditLookupValue.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    Await(TEditLookupValue, AForm.Load());
    AForm.SetDataSources(DataSource.DataSet);

    if ARecordId = '' then
    begin
      AForm.EditMode := Add;
      DataSource.DataSet.Insert;
    end
    else
    begin
      AForm.EditMode := None;
      DataSource.DataSet.Locate(FIdField, ARecordId, []);
    end;

    if Await(TModalResult, AForm.Execute) = mrOK then
    begin
      if ARecordId = '' then
      begin
        lNewValue := DataSource.DataSet.FieldByName('LookupValue').AsString;
        lDescription := DataSource.DataSet.FieldByName('Description').AsString;
        lSortOrder := DataSource.DataSet.FieldByName('SortOrder').AsInteger;
        DataSource.DataSet.Cancel;

        lDeactivatedFound := False;
        DataSource.DataSet.First;
        while not DataSource.DataSet.Eof do
        begin
          if (not DataSource.DataSet.FieldByName('IsActive').AsBoolean) and
             SameText(DataSource.DataSet.FieldByName('LookupValue').AsString, lNewValue) then
          begin
            lDeactivatedFound := True;
            Break;
          end;
          DataSource.DataSet.Next;
        end;

        if lDeactivatedFound then
        begin
          lMsg := Format('A deactivated value %s already exists. Would you like to reactivate it instead?', [QuotedStr(lNewValue)]);
          ConfirmationMsg.Title := 'Reactivate Existing';
          if Await(TModalResult, ConfirmationMsg.ShowDialog(lMsg, mtConfirmation, [mbYes, mbNo])) = mrYes then
          begin
            DataSource.DataSet.Edit;
            DataSource.DataSet.FieldByName('IsActive').AsBoolean := True;
            DataSource.DataSet.FieldByName('Description').AsString := lDescription;
            DataSource.DataSet.FieldByName('SortOrder').AsInteger := lSortOrder;
            DataSource.DataSet.Post;
            Await(Save);
          end;
        end
        else
        begin
          DataSource.DataSet.Insert;
          DataSource.DataSet.FieldByName('LookupValue').AsString := lNewValue;
          DataSource.DataSet.FieldByName('Description').AsString := lDescription;
          DataSource.DataSet.FieldByName('SortOrder').AsInteger := lSortOrder;
          DataSource.DataSet.Post;
          Await(Save);
        end;
      end
      else
      begin
        DataSource.DataSet.Post;
        Await(Save);
      end;
    end;
  finally
    FreeAndNil(AForm);
  end;
end;

procedure TEssentialsLookupEditor.EntitySelectorChange(Sender: TObject);
var
  selectedValue: string;
  lFields: TList<string>;
  fld: string;
  lSelectedField: string;
begin
  selectedValue := EntitySelector.Value;
  FieldSelector.LookupValues.Clear;

  lFields := EssentialsManager.LookUpManager.RegisteredFields[selectedValue];
  lSelectedField := EssentialsManager.LookUpManager.LookUpDataset.FieldByName('FieldName').AsString;

  if Assigned(lFields) then
  begin
    for fld in lFields do
    begin
      FieldSelector.LookupValues.AddPair(fld, TUtils.SplitOnCaps(fld));
      if lSelectedField = fld then
        FieldSelector.ItemIndex := lFields.IndexOf(fld);
    end;

    if (FieldSelector.ItemIndex < 0) and (FieldSelector.LookupValues.Count > 0) then
      FieldSelector.ItemIndex := 0;
  end;
end;

procedure TEssentialsLookupEditor.EssentialsTableGetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: string;
begin
  if ARow = 0 then
    Exit;

  if EssentialsTable.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := ConvertIdFieldsIntoRecords(FIdField);

    if RecordId <> '' then
      AddRowActions(RecordId, AElement.Element)
    else
      AElement.Element.textContent := 'Loading...';
  end;
end;


function TEssentialsLookupEditor.GetJSArrayFromRecordIds(aRecordIds: string): TJSValueDynArray;
var
  recordIds: TArray<string>;
  i, arrLength: Integer;
begin
  recordIds := aRecordIds.Split([';']);
  arrLength := Length(recordIds);
  SetLength(Result, arrLength);

  for i := 0 to arrLength - 1 do
    Result[i] := recordIds[i];
end;

procedure TEssentialsLookupEditor.LoadButtonClick(Sender: TObject);
begin
  inherited;
  LoadData;
end;

procedure TEssentialsLookupEditor.WebFormCreate(Sender: TObject);
begin
  FIdField := 'LookUpValue';
  SetDataSet(EssentialsManager.LookUpManager.LookupValuesDataset);
  LoadEntityList;

  if (EntitySelector.ItemIndex > -1) and (FieldSelector.ItemIndex > -1) then
    LoadData
  else
    RefreshControls(False);
end;

procedure TEssentialsLookupEditor.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('essentials.lookup.PageInfo');
  AddButton := TButton.Create('essentials.lookup.add.button');
  cbPageSize := TComboBox.Create('essentials.lookup.PageSizeSelect');
  EssentialsTable := TDBTableControl.Create('esssentials.lookup.table');
  lcPaginator := TListControl.Create('essentials.lookup.Pagination');
  LoadButton := TButton.Create('essentials.lookup.load.button');
  EntitySelector := TLookupComboBox.Create('essentials.lookup.entity.selector');
  FieldSelector := TLookupComboBox.Create('essentials.lookup.field.selector');
  ConfirmationMsg := TMessageDlg.Create('ConfirmationMsg');
  DataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  AddButton.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  EssentialsTable.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  LoadButton.BeforeLoadDFMValues;
  EntitySelector.BeforeLoadDFMValues;
  FieldSelector.BeforeLoadDFMValues;
  ConfirmationMsg.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  try
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 177;
    lbPaginationInfo.Top := 32;
    lbPaginationInfo.Width := 112;
    lbPaginationInfo.Height := 15;
    lbPaginationInfo.Caption := 'No records to display';
    lbPaginationInfo.ElementFont := efCSS;
    lbPaginationInfo.ElementPosition := epIgnore;
    lbPaginationInfo.HeightStyle := ssAuto;
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthStyle := ssAuto;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    AddButton.SetParentComponent(Self);
    AddButton.Name := 'AddButton';
    AddButton.Left := 72;
    AddButton.Top := 296;
    AddButton.Width := 96;
    AddButton.Height := 25;
    AddButton.Caption := 'Add';
    AddButton.ChildOrder := 7;
    AddButton.ElementClassName := 'btn btn-light';
    AddButton.ElementFont := efCSS;
    AddButton.ElementPosition := epIgnore;
    AddButton.HeightStyle := ssAuto;
    AddButton.HeightPercent := 100.000000000000000000;
    AddButton.WidthStyle := ssAuto;
    AddButton.WidthPercent := 100.000000000000000000;
    SetEvent(AddButton, Self, 'OnClick', 'AddButtonClick');
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 33;
    cbPageSize.Top := 29;
    cbPageSize.Width := 81;
    cbPageSize.Height := 23;
    cbPageSize.ElementClassName := 'form-select';
    cbPageSize.ElementFont := efCSS;
    cbPageSize.ElementPosition := epIgnore;
    cbPageSize.HeightStyle := ssAuto;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.Text := '10';
    cbPageSize.WidthStyle := ssAuto;
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    EssentialsTable.SetParentComponent(Self);
    EssentialsTable.Name := 'EssentialsTable';
    EssentialsTable.Left := 72;
    EssentialsTable.Top := 81;
    EssentialsTable.Width := 505;
    EssentialsTable.Height := 193;
    EssentialsTable.HeightStyle := ssAuto;
    EssentialsTable.WidthStyle := ssAuto;
    EssentialsTable.BorderColor := clSilver;
    EssentialsTable.ChildOrder := 3;
    EssentialsTable.ElementFont := efCSS;
    EssentialsTable.ElementHeaderClassName := 'thead-light';
    EssentialsTable.ElementPosition := epIgnore;
    EssentialsTable.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    EssentialsTable.Footer.ButtonActiveElementClassName := 'btn btn-primary';
    EssentialsTable.Footer.ButtonElementClassName := 'btn btn-light';
    EssentialsTable.Footer.DropDownElementClassName := 'form-control';
    EssentialsTable.Footer.InputElementClassName := 'form-control';
    EssentialsTable.Footer.LinkActiveElementClassName := 'link-primary';
    EssentialsTable.Footer.LinkElementClassName := 'link-secondary';
    EssentialsTable.Footer.ListElementClassName := 'pagination';
    EssentialsTable.Footer.ListItemElementClassName := 'page-item';
    EssentialsTable.Footer.ListLinkElementClassName := 'page-link';
    EssentialsTable.Header.ButtonActiveElementClassName := 'btn btn-primary';
    EssentialsTable.Header.ButtonElementClassName := 'btn btn-light';
    EssentialsTable.Header.DropDownElementClassName := 'form-control';
    EssentialsTable.Header.InputElementClassName := 'form-control';
    EssentialsTable.Header.LinkActiveElementClassName := 'link-primary';
    EssentialsTable.Header.LinkElementClassName := 'link-secondary';
    EssentialsTable.Header.ListElementClassName := 'pagination';
    EssentialsTable.Header.ListItemElementClassName := 'page-item';
    EssentialsTable.Header.ListLinkElementClassName := 'page-link';
    SetEvent(EssentialsTable, Self, 'OnGetCellChildren', 'EssentialsTableGetCellChildren');
    EssentialsTable.Columns.Clear;
    with EssentialsTable.Columns.Add do
    begin
      DataField := 'LookUpValue';
      Title := 'Look Up Value';
    end;
    with EssentialsTable.Columns.Add do
    begin
      DataField := 'SortOrder';
      Title := 'Sort Order';
    end;
    with EssentialsTable.Columns.Add do
    begin
      DataField := 'Description';
      Title := 'Description';
    end;
    with EssentialsTable.Columns.Add do
    begin
      DataField := 'IsActive';
      DataType := cdCheck;
      Title := 'Active';
    end;
    with EssentialsTable.Columns.Add do
    begin
      Title := 'Actions';
    end;
    EssentialsTable.DataSource := DataSource;
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 153;
    lcPaginator.Top := 354;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightStyle := ssAuto;
    lcPaginator.WidthStyle := ssAuto;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.ChildOrder := 3;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementFont := efCSS;
    lcPaginator.ElementPosition := epIgnore;
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Items.Clear;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    lcPaginator.Style := lsPagination;
    LoadButton.SetParentComponent(Self);
    LoadButton.Name := 'LoadButton';
    LoadButton.Left := 320;
    LoadButton.Top := 50;
    LoadButton.Width := 96;
    LoadButton.Height := 25;
    LoadButton.Caption := 'Load';
    LoadButton.ChildOrder := 2;
    LoadButton.ElementClassName := 'btn btn-light';
    LoadButton.ElementFont := efCSS;
    LoadButton.ElementPosition := epIgnore;
    LoadButton.HeightStyle := ssAuto;
    LoadButton.HeightPercent := 100.000000000000000000;
    LoadButton.WidthStyle := ssAuto;
    LoadButton.WidthPercent := 100.000000000000000000;
    SetEvent(LoadButton, Self, 'OnClick', 'LoadButtonClick');
    EntitySelector.SetParentComponent(Self);
    EntitySelector.Name := 'EntitySelector';
    EntitySelector.Left := 103;
    EntitySelector.Top := 412;
    EntitySelector.Width := 186;
    EntitySelector.Height := 22;
    EntitySelector.ElementClassName := 'form-select';
    EntitySelector.ElementFont := efCSS;
    EntitySelector.HeightPercent := 100.000000000000000000;
    EntitySelector.WidthPercent := 100.000000000000000000;
    SetEvent(EntitySelector, Self, 'OnChange', 'EntitySelectorChange');
    EntitySelector.ItemIndex := -1;
    FieldSelector.SetParentComponent(Self);
    FieldSelector.Name := 'FieldSelector';
    FieldSelector.Left := 303;
    FieldSelector.Top := 412;
    FieldSelector.Width := 179;
    FieldSelector.Height := 22;
    FieldSelector.ElementClassName := 'form-select';
    FieldSelector.ElementFont := efCSS;
    FieldSelector.HeightPercent := 100.000000000000000000;
    FieldSelector.WidthPercent := 100.000000000000000000;
    FieldSelector.ItemIndex := -1;
    ConfirmationMsg.SetParentComponent(Self);
    ConfirmationMsg.Name := 'ConfirmationMsg';
    ConfirmationMsg.Left := 33;
    ConfirmationMsg.Top := 252;
    ConfirmationMsg.Width := 24;
    ConfirmationMsg.Height := 24;
    ConfirmationMsg.ElementClassName := 'PopUpForm';
    ConfirmationMsg.Buttons := [];
    ConfirmationMsg.Opacity := 0.200000000000000000;
    ConfirmationMsg.Title := 'Confirm';
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    SetEvent(DataSource, Self, 'OnStateChange', 'DataSourceStateChange');
    DataSource.Left := 528;
    DataSource.Top := 288;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    AddButton.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    EssentialsTable.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    LoadButton.AfterLoadDFMValues;
    EntitySelector.AfterLoadDFMValues;
    FieldSelector.AfterLoadDFMValues;
    ConfirmationMsg.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
  end;
end;

end.
